import script from "./stdOnboardingSecondPage.vue?vue&type=script&setup=true&lang=js"
export * from "./stdOnboardingSecondPage.vue?vue&type=script&setup=true&lang=js"

import "./stdOnboardingSecondPage.vue?vue&type=style&index=0&id=169fda4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-169fda4a"]])

export default __exports__